import { getValueForField } from "./getValueForField";

export function prefillFields({
  fields,
  userDetail,
  cbtTravelersIds,
  cbt,
  previousBookingFormFields,
  codeBook,
}) {
  const fieldsKeys = Object.keys(fields);

  const prefilledFields = fieldsKeys
    .map((fieldName) => fields[fieldName])
    .map((field) =>
      prefillField({
        fields,
        field,
        userDetail,
        cbtTravelersIds,
        cbt,
        previousBookingFormField: previousBookingFormFields[field.name],
        codeBook,
      })
    );

  const ret = {};

  prefilledFields.forEach(
    // eslint-disable-next-line no-return-assign
    (prefilledField) => (ret[prefilledField.name] = prefilledField)
  );

  return ret;
}

function prefillField({
  fields,
  field,
  userDetail,
  cbtTravelersIds,
  cbt,
  previousBookingFormField,
  codeBook,
}) {
  const value = getValueForField({
    fields,
    field,
    userDetail,
    cbtTravelersIds,
    cbt,
    previousBookingFormField,
    codeBook,
  });

  if (field && field.name && field.name.includes("_lastname")) {
    return { ...field, minLength: 2, value };
  }
  if (field && field.name && field.name.includes("email")) {
    return { ...field, noSpaceAround: true, value };
  }

  return { ...field, value };
}
